export const ITEM_CATEGORIES = [
  'Antiques',
  'Art',
  'Books',
  'Chef experiences',
  'Collectables',
  'Computers/tablets',
  'Dining experiences',
  'Electronics',
  'Entertainment',
  'Entertainment memorabilia',
  'Gift Baskets',
  'Gift Cards',
  'Golf Clubs',
  'Golf Experiences',
  'Health and Beauty',
  'Jewelry/Watches',
  'Music/Concert tickets or experiences',
  'Spa Experiences',
  'Specialty Services',
  'Sporting goods',
  'Sports memorabilia',
  'Sports experiences/tickets',
  'Tickets/experiences',
  'Travel',
  'Everything Else'
]

export const FETCH_ITEM_RESOURCE = 'mycharity/item/'
export const FETCH_ITEM_REQUEST = 'FETCH_ITEM_REQUEST'
export const FETCH_ITEM_SUCCESS = 'FETCH_ITEM_SUCCESS'
export const FETCH_ITEM_FAILED = 'FETCH_ITEM_FAILED'

export const UPDATE_ITEM = {
  RESOURCE: 'update:item',
  REQUEST: 'UPDATE_ITEM_REQUEST',
  SUCCESS: 'UPDATE_ITEM_SUCCESS',
  FAILED: 'UPDATE_ITEM_FAILED'
}



// WEBPACK FOOTER //
// ./src/services/mycharity/item/constants.js